import General from '../views/settings/General.vue'
import Payment from '../views/settings/Payment.vue'
import Loyalty from '../views/settings/Loyalty.vue'
import Taxes from '../views/settings/Taxes.vue'
import Tickets from '../views/settings/Tickets.vue'
import Printers from '../views/settings/Printers.vue'
import Stores from '../views/settings/Stores.vue'
import Devices from '../views/settings/Devices.vue'
import Buttons from '../views/settings/Buttons.vue'
import Currency from '../views/settings/Currency.vue'
import Receipt from '../views/settings/Receipts.vue'
import NDS from '../views/settings/NDS.vue'
import Options from '../views/settings/Options.vue'
import Organizations from '../views/settings/Organizations.vue'
import ClientStatus from '../views/settings/ClientStatus.vue'

const settings = [
  {path: '/settings/general', name: 'settings_general', component: General},
  {path: '/settings/payment', name: 'settings_payment', component: Payment},
  {path: '/settings/loyalty', name: 'settings_loyalty', component: Loyalty},
  {path: '/settings/taxes', name: 'settings_taxes', component: Taxes},
  {path: '/settings/tickets', name: 'settings_tickets', component: Tickets},
  {path: '/settings/printers', name: 'settings_printers', component: Printers},
  {path: '/settings/stores', name: 'settings_stores', component: Stores},
  {path: '/settings/devices', name: 'settings_devices', component: Devices},
  {path: '/settings/buttons', name: 'settings_buttons', component: Buttons},
  {path: '/settings/currency', name: 'settings_currency', component: Currency},
  {path: '/settings/receipt', name: 'settings_receipt', component: Receipt},
  {path: '/settings/nds', name: 'settings_nds', component: NDS},
  {path: '/settings/options', name: 'settings_options', component: Options},
  {path: '/settings/organization', name: 'settings_organization', component: Organizations},
  {path: '/settings/client/status', name: 'settings_client_status', component: ClientStatus}
]

export default {
  settings
}


// function lazyLoad(view) {
//   return () => import(`@/views/settings/${view}.vue`)
// }
// const settings = [
//   { path: '/settings/general', name: 'settings_general', component: lazyLoad('General') },
//   { path: '/settings/payment', name: 'settings_payment', component: lazyLoad('Payment') },
//   { path: '/settings/loyalty', name: 'settings_loyalty', component: lazyLoad('Loyalty') },
//   { path: '/settings/taxes', name: 'settings_taxes', component: lazyLoad('Taxes') },
//   { path: '/settings/tickets', name: 'settings_tickets', component: lazyLoad('Tickets') },
//   { path: '/settings/printers', name: 'settings_printers', component: lazyLoad('Printers') },
//   { path: '/settings/stores', name: 'settings_stores', component: lazyLoad('Stores') },
//   { path: '/settings/devices', name: 'settings_devices', component: lazyLoad('Devices') },
//   { path: '/settings/buttons', name: 'settings_buttons', component: lazyLoad('Buttons') },
//   { path: '/settings/currency', name: 'settings_currency', component: lazyLoad('Currency') },
//   { path: '/settings/receipt', name: 'settings_receipt', component: lazyLoad('Receipts') },
//   { path: '/settings/nds', name: 'settings_nds', component: lazyLoad('NDS') },
//   { path: '/settings/options', name: 'settings_options', component: lazyLoad('Options') },
//   { path: '/settings/organization', name: 'settings_organization', component: lazyLoad('Organizations') },
//   { path: '/settings/client/status', name: 'settings_client_status', component: lazyLoad('ClientStatus') }
// ]